__turbopack_context__.v({
  "dot": "CjVnEa_dot",
  "dots": "CjVnEa_dots",
});
